<template>
  <component :is="reportComponent" />
</template>

<script>
import { useGateReportStore } from "@/stores/gateReport"
import GateReportProjects from "@/components/gateReport/reports/GateReportProjects"
import GateReportAnprProjectsConfig from "@/components/gateReport/reports/GateReportAnprProjectsConfig"
import { PERMISSIONS } from "@/constants/permissions"
import { GateReportTypeRoute } from "@evercam/shared/types/components"

export default {
  meta: {
    requiredPermissions: [PERMISSIONS.GATE_REPORT.VIEW],
  },
  components: {
    GateReportProjects,
    GateReportAnprProjectsConfig,
  },
  head() {
    return {
      title: this.reportTitle,
      meta: [
        { charset: "utf-8" },
        { name: "viewport", content: "width=device-width, initial-scale=1" },
        {
          hid: "description",
          name: "description",
          content: "",
        },
      ],
    }
  },
  computed: {
    reportComponent() {
      const map = {
        [GateReportTypeRoute.GateReportProjects]: "GateReportProjects",
        [GateReportTypeRoute.GateReportAnprProjects]:
          "GateReportAnprProjectsConfig",
      }

      return map[this.$route.params.report] || "GateReportProjects"
    },
    reportTitle() {
      return this.$route.params.report ===
        GateReportTypeRoute.GateReportAnprProjects
        ? "ANPR Gate Report"
        : "Gate Report"
    },
  },
  mounted() {
    useGateReportStore().updateBreadcrumbs()
  },
}
</script>
